// Angular and Ionic imports
import { Injectable } from '@angular/core';

// Custom Services
import { FirestoreService } from "./firestore.service";

// Data models
import { Globals } from "../model/globals";
import { Observable } from "rxjs";

@Injectable({
  providedIn: 'root'
})
export class GlobalService {

  constructor(
    private firestoreService: FirestoreService
  ) { }

  /****************************************************************************************************
   * Load Globals (app-wide data) (collection) - Single Document
   * 
   * @returns Observable<Globals>
   ****************************************************************************************************/
  loadGlobals(): Observable<Globals> {
    return this.firestoreService.subscribeDoc<Globals>("pages/variables");
  } // End of loadGlobals()

} // End of Class GlobalService
